// The desktop left pane is selected by a single number: a watchlist id (>= 0), or one of these
// sentinels for the panes that are not watchlists. Copy-trading passes the same value around, so
// the numbers are part of that contract and cannot be renumbered freely.
export const DESKTOP_PANE = {
    investors: -1,
    investments: -2,
    aiStrategy: -3,
} as const;

// Width of the desktop side columns. The chart between them is sized against it.
export const DESKTOP_COLUMN_WIDTH = 375;
